import { render } from "./SuccessRegister.vue?vue&type=template&id=7c3f6700"
import script from "./SuccessRegister.vue?vue&type=script&lang=js"
export * from "./SuccessRegister.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__